import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress
} from '@mui/material'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { deleteSetupTemplate } from '../../../redux/notificationCenter'

type Props = {
  open: boolean
  onClose: () => void
  templateId: string
  templateName?: string
}

export default function DeleteSetupTemplateModal({
  open,
  onClose,
  templateId,
  templateName
}: Props) {
  const dispatch = useDispatch()
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    if (!templateId) {
      // TODO: Add proper validation error handling
      return
    }

    try {
      setIsDeleting(true)
      ;(dispatch as any)(deleteSetupTemplate(templateId))
      onClose()
    } catch (error) {
      // TODO: Add proper error handling/notification
      // Error details: error
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete {templateName ? `"${templateName}"` : 'this template'}?{' '}
          This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="contained"
          disabled={isDeleting || !templateId}
          startIcon={isDeleting ? <CircularProgress size={16} /> : undefined}>
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
